// extracted by mini-css-extract-plugin
export default {"scroll_container":"ScrollTextHome_scroll_container__bZq8q","scroll_text":"ScrollTextHome_scroll_text__v8WF6","my-animation":"ScrollTextHome_my-animation__MqUHi"};